const API_MASTER = [
  {
    api_id: 1,
    api_code: 'API-001',
    api_name: 'Amoxicillin Trihydrate',
    pde_value: 3.75,
    pde_unit: 'mg',
    ld50_value: 5000,
    ld50_value_unit: 'mg/kg',
    solubility_classification: 'Slightly Soluble',
    cleanability_rating: 'Difficult',
    therapeutic_dose: 125,
    therapeutic_dose_unit: 'mg',
    max_daily_dose: 6000,
    max_daily_dose_unit: 'mg'
  },
  {
    api_id: 2,
    api_code: 'API-002',
    api_name: 'Clavulanate potassium',
    pde_value: 3.75,
    pde_unit: 'mg',
    ld50_value: 4526,
    ld50_value_unit: 'mg/kg',
    solubility_classification: 'Freely Soluble',
    cleanability_rating: 'Easy',
    therapeutic_dose: 28.5,
    therapeutic_dose_unit: 'mg',
    max_daily_dose: 250,
    max_daily_dose_unit: 'mg'
  },
  {
    api_id: 3,
    api_code: 'API-003',
    api_name: 'Ampicillin Trihydrate',
    pde_value: 100,
    pde_unit: 'mg',
    ld50_value: 10000,
    ld50_value_unit: 'mg/kg',
    solubility_classification: 'Slightly Soluble',
    cleanability_rating: 'Difficult',
    therapeutic_dose: 125,
    therapeutic_dose_unit: 'mg',
    max_daily_dose: 3500,
    max_daily_dose_unit: 'mg'
  },
  {
    api_id: 4,
    api_code: 'API-004',
    api_name: 'Cloxacillin Sodium',
    pde_value: 10,
    pde_unit: 'mg',
    ld50_value: 5000,
    ld50_value_unit: 'mg/kg',
    solubility_classification: 'Freely Soluble',
    cleanability_rating: 'Easy',
    therapeutic_dose: 250,
    therapeutic_dose_unit: 'mg',
    max_daily_dose: 3000,
    max_daily_dose_unit: 'mg'
  },
  {
    api_id: 5,
    api_code: 'API-005',
    api_name: 'Phenoxymethyl Penicillin Potassium',
    pde_value: 100,
    pde_unit: 'mg',
    ld50_value: 1040,
    ld50_value_unit: 'mg/kg',
    solubility_classification: 'Freely Soluble',
    cleanability_rating: 'Easy',
    therapeutic_dose: 125,
    therapeutic_dose_unit: 'mg',
    max_daily_dose: 3000,
    max_daily_dose_unit: 'mg'
  },
  {
    api_id: 6,
    api_code: 'API-006',
    api_name: 'Sultamicillin Tosilate Dihydrate',
    pde_value: 10,
    pde_unit: 'mg',
    ld50_value: 10000,
    ld50_value_unit: 'mg/kg',
    solubility_classification: 'Practically Insoluble',
    cleanability_rating: 'Difficult',
    therapeutic_dose: 375,
    therapeutic_dose_unit: 'mg',
    max_daily_dose: 2250,
    max_daily_dose_unit: 'mg'
  },
  {
    api_id: 7,
    api_code: 'API-007',
    api_name: 'Dicloxacillin Sodium',
    pde_value: 1.66,
    pde_unit: 'mg',
    ld50_value: 3579,
    ld50_value_unit: 'mg/kg',
    solubility_classification: 'Freely Soluble',
    cleanability_rating: 'Easy',
    therapeutic_dose: 125,
    therapeutic_dose_unit: 'mg',
    max_daily_dose: 1000,
    max_daily_dose_unit: 'mg'
  },
  {
    api_id: 8,
    api_code: 'API-008',
    api_name: 'Flucloxacillin Sodium',
    pde_value: 2,
    pde_unit: 'mg',
    ld50_value: 11000,
    ld50_value_unit: 'mg/kg',
    solubility_classification: 'Freely Soluble',
    cleanability_rating: 'Easy',
    therapeutic_dose: 250,
    therapeutic_dose_unit: 'mg',
    max_daily_dose: 8000,
    max_daily_dose_unit: 'mg'
  },
  {
    api_id: 9,
    api_code: 'API-009',
    api_name: 'Oxacillin Sodium',
    pde_value: 0.2,
    pde_unit: 'mg',
    ld50_value: 10000,
    ld50_value_unit: 'mg/kg',
    solubility_classification: 'Freely Soluble',
    cleanability_rating: 'Easy',
    therapeutic_dose: 1000,
    therapeutic_dose_unit: 'mg',
    max_daily_dose: 8000,
    max_daily_dose_unit: 'mg'
  }
];

const API_MASTER_NORMALIZED = API_MASTER.map((api) => ({
  ...api,
  ld50_unit: api.ld50_value_unit
}));

const API_BY_NAME = API_MASTER_NORMALIZED.reduce((acc, api) => {
  acc[String(api.api_name || '').toLowerCase()] = api;
  return acc;
}, {});

const makeApiEntry = (apiName, labelClaim, labelUnit, overrides = {}) => {
  const base = API_BY_NAME[String(apiName || '').toLowerCase()] || {
    api_id: '',
    api_code: '',
    api_name: apiName || ''
  };
  return {
    api_id: base.api_id,
    api_code: base.api_code,
    api_name: base.api_name,
    label_claim: labelClaim,
    label_claim_unit: labelUnit,
    therapeutic_dose: base.therapeutic_dose,
    therapeutic_dose_unit: base.therapeutic_dose_unit,
    max_daily_dose: base.max_daily_dose,
    max_daily_dose_unit: base.max_daily_dose_unit,
    pde_value: base.pde_value,
    pde_unit: base.pde_unit,
    ld50_value: base.ld50_value,
    ld50_value_unit: base.ld50_value_unit,
    ld50_unit: base.ld50_unit,
    solubility_classification: base.solubility_classification,
    cleanability_rating: base.cleanability_rating,
    ...overrides
  };
};

const buildProducts = (defs, { trainId, dosageForm, codePrefix, startId }) => {
  return defs.map((def, index) => ({
    product_id: startId + index,
    product_code: `${codePrefix}-${String(index + 1).padStart(3, '0')}`,
    product_name: def.name,
    dosage_form: dosageForm,
    equipment_train_id: trainId,
    batch_size: def.batch_size,
    batch_size_unit: def.batch_unit || 'kg',
    status: 'Approved',
    apis: def.apis.map((api) =>
      makeApiEntry(api.name, api.label_claim, api.label_unit, api.overrides || {})
    )
  }));
};

const TABLET_PRODUCTS = [
  {
    name: 'Amoxicillin and Clavulanate potassium Tablets 500 mg + 125 mg',
    batch_size: 125,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 500, label_unit: 'mg/Unit' },
      { name: 'Clavulanate potassium', label_claim: 125, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Amoxicillin and Clavulanate Potassium Tablets 250 mg + 125 mg',
    batch_size: 66.8,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 250, label_unit: 'mg/Unit' },
      { name: 'Clavulanate potassium', label_claim: 125, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Amoxicillin Tablets 500 mg',
    batch_size: 66.3,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 500, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Amoxicillin Tablets 250 mg',
    batch_size: 60,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 250, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Ampicillin Tablets 1 g',
    batch_size: 125,
    apis: [
      { name: 'Ampicillin Trihydrate', label_claim: 1000, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Ampicillin Tablets 500 mg',
    batch_size: 66.3,
    apis: [
      { name: 'Ampicillin Trihydrate', label_claim: 500, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Cloxacillin Tablets 250 mg',
    batch_size: 60,
    apis: [
      { name: 'Cloxacillin Sodium', label_claim: 250, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Cloxacillin Tablets 500 mg',
    batch_size: 68.85,
    apis: [
      { name: 'Cloxacillin Sodium', label_claim: 500, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Dispersible Amoxicillin Tablets 125 mg',
    batch_size: 60,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 125, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Phenoxymethyl Penicillin Tablets 250 mg',
    batch_size: 63,
    apis: [
      { name: 'Phenoxymethyl Penicillin Potassium', label_claim: 250, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Phenoxymethyl Penicillin Tablets 125 mg',
    batch_size: 60,
    apis: [
      { name: 'Phenoxymethyl Penicillin Potassium', label_claim: 125, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Phenoxymethylpenicillin Potassium Tablets 500 mg',
    batch_size: 65,
    apis: [
      { name: 'Phenoxymethyl Penicillin Potassium', label_claim: 500, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Ampicillin Tablets 100 mg',
    batch_size: 66.3,
    apis: [
      { name: 'Ampicillin Trihydrate', label_claim: 100, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Amoxicillin and Clavulanate potassium Tablets 500mg+62.5 mg',
    batch_size: 91.8,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 500, label_unit: 'mg/Unit' },
      { name: 'Clavulanate potassium', label_claim: 62.5, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Amoxicillin and Clavulanate potassium Tablets 250 mg + 62.5mg',
    batch_size: 61.78,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 250, label_unit: 'mg/Unit' },
      { name: 'Clavulanate potassium', label_claim: 62.5, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Amoxicillin and Clavulanate potassium Tablets 875 mg +125 mg',
    batch_size: 147,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 875, label_unit: 'mg/Unit' },
      { name: 'Clavulanate potassium', label_claim: 125, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Dispersible Amoxicillin Tablets 250 mg',
    batch_size: 60,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 250, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Sultamicillin Tablets 375 mg',
    batch_size: 66.3,
    apis: [
      { name: 'Sultamicillin Tosilate Dihydrate', label_claim: 375, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Sultamicillin Tablets 750 mg',
    batch_size: 117.8,
    apis: [
      { name: 'Sultamicillin Tosilate Dihydrate', label_claim: 750, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Dispersible Amoxicillin Tablets 1000 mg',
    batch_size: 220,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 1000, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Amoxicillin Tablets 50 mg',
    batch_size: 60,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 50, label_unit: 'mg/Unit' }
    ]
  }
];

const CAPSULE_PRODUCTS = [
  {
    name: 'Amoxicillin Capsules 250 mg',
    batch_size: 125,
    apis: [
      {
        name: 'Amoxicillin Trihydrate',
        label_claim: 250,
        label_unit: 'mg/Unit',
        overrides: { ld50_value: 12000 }
      }
    ]
  },
  {
    name: 'Amoxicillin Capsules 500 mg',
    batch_size: 125,
    apis: [
      {
        name: 'Amoxicillin Trihydrate',
        label_claim: 500,
        label_unit: 'mg/Unit',
        overrides: { ld50_value: 12000 }
      }
    ]
  },
  {
    name: 'Ampicillin + Cloxacillin Capsules 250 mg + 250 mg',
    batch_size: 125,
    apis: [
      { name: 'Ampicillin Trihydrate', label_claim: 250, label_unit: 'mg/Unit' },
      { name: 'Cloxacillin Sodium', label_claim: 250, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Ampicillin Capsules 250 mg',
    batch_size: 125,
    apis: [
      { name: 'Ampicillin Trihydrate', label_claim: 250, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Ampicillin Capsules 500 mg',
    batch_size: 125,
    apis: [
      { name: 'Ampicillin Trihydrate', label_claim: 500, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Cloxacillin Sodium Capsules 250 mg',
    batch_size: 125,
    apis: [
      { name: 'Cloxacillin Sodium', label_claim: 250, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Cloxacillin Sodium Capsules 500 mg',
    batch_size: 125,
    apis: [
      { name: 'Cloxacillin Sodium', label_claim: 500, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Dicloxacillin Sodium Capsules 500 mg',
    batch_size: 125,
    apis: [
      { name: 'Dicloxacillin Sodium', label_claim: 500, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Flucloxacillin Capsules 250 mg',
    batch_size: 125,
    apis: [
      { name: 'Flucloxacillin Sodium', label_claim: 250, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Oxacillin Capsules 500 mg',
    batch_size: 125,
    apis: [
      { name: 'Oxacillin Sodium', label_claim: 500, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Flucloxacillin Capsules 500 mg',
    batch_size: 125,
    apis: [
      { name: 'Flucloxacillin Sodium', label_claim: 500, label_unit: 'mg/Unit' }
    ]
  },
  {
    name: 'Amoxicillin Capsules 1000 mg',
    batch_size: 125,
    apis: [
      {
        name: 'Amoxicillin Trihydrate',
        label_claim: 1000,
        label_unit: 'mg/Unit',
        overrides: { ld50_value: 12000 }
      }
    ]
  },
  {
    name: 'Flucloxacillin and Amoxicillin Capsules 250 mg+250mg',
    batch_size: 125,
    apis: [
      { name: 'Flucloxacillin Sodium', label_claim: 250, label_unit: 'mg/Unit' },
      {
        name: 'Amoxicillin Trihydrate',
        label_claim: 250,
        label_unit: 'mg/Unit',
        overrides: { ld50_value: 12000 }
      }
    ]
  }
];

const DRY_SYRUP_PRODUCTS = [
  {
    name: 'Amoxicillin and Clavulanate Potassium for Oral Suspension 200 mg+28.8mg/5mL',
    batch_size: 100,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 200, label_unit: 'mg/5mL' },
      { name: 'Clavulanate potassium', label_claim: 28.8, label_unit: 'mg/5mL' }
    ]
  },
  {
    name: 'Amoxicillin and Clavulanate Potassium for Oral Suspension 200 mg+28.5mg/5mL',
    batch_size: 100,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 200, label_unit: 'mg/5mL' },
      { name: 'Clavulanate potassium', label_claim: 28.5, label_unit: 'mg/5mL' }
    ]
  },
  {
    name: 'Amoxicillin and Clavulanate Potassium for Oral Suspension 250 mg+62.5mg/5mL',
    batch_size: 100,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 250, label_unit: 'mg/5mL' },
      { name: 'Clavulanate potassium', label_claim: 62.5, label_unit: 'mg/5mL' }
    ]
  },
  {
    name: 'Amoxicillin For Oral Suspension 250 mg/5mL',
    batch_size: 100,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 250, label_unit: 'mg/5mL' }
    ]
  },
  {
    name: 'Amoxicillin For Oral Suspension 125 mg/5mL',
    batch_size: 100,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 125, label_unit: 'mg/5mL' }
    ]
  },
  {
    name: 'Ampicillin and Cloxacillin For Oral Suspension 125 mg + 125 mg/5mL',
    batch_size: 100,
    apis: [
      { name: 'Ampicillin Trihydrate', label_claim: 125, label_unit: 'mg/5mL' },
      { name: 'Cloxacillin Sodium', label_claim: 125, label_unit: 'mg/5mL' }
    ]
  },
  {
    name: 'Ampicillin Oral Suspension 125 mg/5mL',
    batch_size: 100,
    apis: [
      { name: 'Ampicillin Trihydrate', label_claim: 125, label_unit: 'mg/5mL' }
    ]
  },
  {
    name: 'Ampicillin Oral Suspension 250 mg/5mL',
    batch_size: 100,
    apis: [
      { name: 'Ampicillin Trihydrate', label_claim: 250, label_unit: 'mg/5mL' }
    ]
  },
  {
    name: 'Dicloxacillin Oral Suspension 250 mg/5mL',
    batch_size: 100,
    apis: [
      { name: 'Dicloxacillin Sodium', label_claim: 250, label_unit: 'mg/5mL' }
    ]
  },
  {
    name: 'Penicillin V For Oral Suspension 125 mg/5mL',
    batch_size: 100,
    apis: [
      { name: 'Phenoxymethyl Penicillin Potassium', label_claim: 125, label_unit: 'mg/5mL' }
    ]
  },
  {
    name: 'Cloxacillin Sodium for Oral Solution 125 mg/5mL',
    batch_size: 100,
    apis: [
      { name: 'Cloxacillin Sodium', label_claim: 125, label_unit: 'mg/5mL' }
    ]
  },
  {
    name: 'Phenoxymethylpenicillin oral solution 250 mg/5mL',
    batch_size: 100,
    apis: [
      { name: 'Phenoxymethyl Penicillin Potassium', label_claim: 250, label_unit: 'mg/5mL' }
    ]
  },
  {
    name: 'Amoxicillin for oral suspension 500 mg/5mL',
    batch_size: 100,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 500, label_unit: 'mg/5mL' }
    ]
  },
  {
    name: 'Amoxicillin Powder for Oral Suspension (after reconstitution: 400 mg/5mL)',
    batch_size: 100,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 400, label_unit: 'mg/5mL' }
    ]
  },
  {
    name: 'Amoxicillin & Clavulanate Potassium for Oral Suspension 400 mg+57 mg/5mL',
    batch_size: 100,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 400, label_unit: 'mg/5mL' },
      { name: 'Clavulanate potassium', label_claim: 57, label_unit: 'mg/5mL' }
    ]
  },
  {
    name: 'Sultamicillin Powder for Oral Suspension (Sultamicillin 250 mg/5mL)',
    batch_size: 100,
    apis: [
      { name: 'Sultamicillin Tosilate Dihydrate', label_claim: 250, label_unit: 'mg/5mL' }
    ]
  },
  {
    name: 'Amoxicillin & Clavulanic acid powder for Oral Suspension 1000 mg+125 mg',
    batch_size: 100,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 1000, label_unit: 'mg/5mL' },
      { name: 'Clavulanate potassium', label_claim: 125, label_unit: 'mg/5mL' }
    ]
  },
  {
    name: 'Amoxicillin and Clavulanate Potassium for Oral Suspension 125 mg+31.25 mg/5mL',
    batch_size: 100,
    apis: [
      { name: 'Amoxicillin Trihydrate', label_claim: 125, label_unit: 'mg/5mL' },
      { name: 'Clavulanate potassium', label_claim: 31.25, label_unit: 'mg/5mL' }
    ]
  }
];

const tabletProducts = buildProducts(TABLET_PRODUCTS, {
  trainId: 1,
  dosageForm: 'Tablet',
  codePrefix: 'TAB',
  startId: 1
});

const capsuleProducts = buildProducts(CAPSULE_PRODUCTS, {
  trainId: 2,
  dosageForm: 'Capsule',
  codePrefix: 'CAP',
  startId: tabletProducts.length + 1
});

const drySyrupProducts = buildProducts(DRY_SYRUP_PRODUCTS, {
  trainId: 3,
  dosageForm: 'Dry Syrup',
  codePrefix: 'DRY',
  startId: tabletProducts.length + capsuleProducts.length + 1
});

export const SAMPLE_APIS = API_MASTER_NORMALIZED;
export const SAMPLE_PRODUCTS = [...tabletProducts, ...capsuleProducts, ...drySyrupProducts];

export const SAMPLE_TRAINS = [
  { train_id: 1, train_code: 'TRN-TAB-01', train_name: 'Tablet Line', status: 'Approved', total_surface_area: 537316.94 },
  { train_id: 2, train_code: 'TRN-CAP-01', train_name: 'Capsule Line', status: 'Approved', total_surface_area: 837614.73 },
  { train_id: 3, train_code: 'TRN-DRY-01', train_name: 'Dry Syrup Line', status: 'Approved', total_surface_area: 211097.9 }
];

const buildEquipment = (items, { prefix, startId, line }) => {
  return items.map((item, index) => ({
    equipment_id: startId + index,
    equipment_code: `${prefix}-${String(index + 1).padStart(3, '0')}`,
    equipment_name: item.name,
    equipment_type: item.type || 'Processing',
    production_line: line,
    status: 'Active',
    is_dedicated: 0,
    is_shared: 1,
    surface_area: item.area
  }));
};

const TABLET_EQUIPMENT = [
  { name: 'Rapid Mixer Granulator', area: 23022 },
  { name: 'Fluid Bed Dryer -I (Gr-I)', area: 58377 },
  { name: 'Fluid Bed Dryer-II (Gr-II)', area: 58377 },
  { name: "Vibro Sifter 30'' (Gr-I)", area: 21662 },
  { name: "Vibro Sifter 30'' (Gr-II)", area: 21662 },
  { name: 'Multimill (Gr-I)', area: 22483 },
  { name: 'Multimill (Gr-II)', area: 22483 },
  { name: 'Octagonal Blender 600 Ltr.', area: 58615 },
  { name: 'Octagonal Blender - 1250 Ltrs', area: 70913 },
  { name: 'Compression-I', area: 11712.85 },
  { name: 'Compression-II', area: 7278.78 },
  { name: 'Metal Detector -I (Compression-I)', area: 1721.24 },
  { name: 'Metal Detector -II (Compression-I)', area: 1721.24 },
  { name: 'De-Duster Machine-I (Compression-I)', area: 5393.21 },
  { name: 'De-Duster Machine-II (Compression-I)', area: 5393.21 },
  { name: 'Metal Detector -I (Compression-II)', area: 1721.24 },
  { name: 'Metal Detector -II (Compression-II)', area: 1721.24 },
  { name: 'De-Duster Machine-I (Compression-II)', area: 5393.21 },
  { name: 'De-Duster Machine-II (Compression-II)', area: 5393.21 },
  { name: 'Autocoater - 48" -I', area: 78500 },
  { name: 'Autocoater - 48" -II (Elicon)', area: 78553 },
  { name: 'VTD-I (Tray)', area: 95600 },
  { name: 'VTD-II (Tray)', area: 95600 },
  { name: 'Inspection Tray (Tray 05)', area: 19916.67 },
  { name: 'BQS', area: 20477.77 },
  { name: 'Strip Packing Machine', area: 7565 },
  { name: 'Analytical balance Pan', area: 59.47 },
  { name: 'Sampling Rod', area: 3282.58 },
  { name: 'Scoop (Dispensing)', area: 714.35 },
  { name: 'Scoop (Manufacturing)', area: 714.35 }
];

const CAPSULE_EQUIPMENT = [
  { name: "Vibro Sifter 30'' (Capsule Blending)", area: 21662 },
  { name: 'Multimill (Capsule Blending)', area: 22483 },
  { name: 'Inspection Tray (Tray 05)', area: 19916.67 },
  { name: 'BQS', area: 20477.77 },
  { name: 'Strip Packing Machine', area: 7565 },
  { name: 'Capsule filling machine', area: 675670.3 },
  { name: 'Metal Detector (Capsule filling)', area: 1721.24 },
  { name: 'Octagonal Blender 1250 Ltr (Capsule Blending)', area: 70913 },
  { name: 'Analytical balance Pan', area: 59.47 },
  { name: 'Sampling Rod', area: 3282.58 },
  { name: 'Scoop (Dispensing)', area: 714.35 },
  { name: 'Scoop (Manufacturing)', area: 714.35 }
];

const DRY_SYRUP_EQUIPMENT = [
  { name: 'Rapid Mixer Granulator', area: 23022 },
  { name: 'Fluid Bed Dryer -I (Gr-I)', area: 58377 },
  { name: 'Fluid Bed Dryer-II (Gr-II)', area: 58377 },
  { name: "Vibro Sifter 30'' (Gr-I)", area: 21662 },
  { name: "Vibro Sifter 30'' (Gr-II)", area: 21662 },
  { name: 'Multimill (Gr-I)', area: 22483 },
  { name: 'Multimill (Gr-II)', area: 22483 },
  { name: 'Octagonal Blender 600 Ltr.', area: 58615 },
  { name: 'Octagonal Blender - 1250 Ltrs', area: 70913 },
  { name: 'Automatic Rotary Volumetric Dry Syrup Filling Machine', area: 9870.15 },
  { name: 'Analytical balance Pan', area: 59.47 },
  { name: 'Sampling Rod', area: 3282.58 },
  { name: 'Scoop (Dispensing)', area: 714.35 },
  { name: 'Scoop (Manufacturing)', area: 714.35 }
];

const tabletEquipment = buildEquipment(TABLET_EQUIPMENT, { prefix: 'EQ-TAB', startId: 1001, line: 'Tablet Line' });
const capsuleEquipment = buildEquipment(CAPSULE_EQUIPMENT, { prefix: 'EQ-CAP', startId: 2001, line: 'Capsule Line' });
const drySyrupEquipment = buildEquipment(DRY_SYRUP_EQUIPMENT, { prefix: 'EQ-DRY', startId: 3001, line: 'Dry Syrup Line' });

export const SAMPLE_EQUIPMENT = [...tabletEquipment, ...capsuleEquipment, ...drySyrupEquipment];

export const SAMPLE_EQUIPMENT_PARTS = SAMPLE_EQUIPMENT.map((eq) => ({
  equipment_part_id: eq.equipment_id * 10 + 1,
  equipment_id: eq.equipment_id,
  part_code: `${eq.equipment_code}-P01`,
  part_name: 'Product Contact Surface',
  contact_type: 'Direct',
  material_of_construction: 'SS 316L',
  surface_area: eq.surface_area,
  surface_area_unit: 'cm²'
}));

const makeEquipmentMap = (equipmentList) => {
  return equipmentList.reduce((acc, eq) => {
    acc[eq.equipment_name] = eq;
    return acc;
  }, {});
};

const buildMembers = (equipmentList, equipmentNames, startId) => {
  const map = makeEquipmentMap(equipmentList);
  return equipmentNames.map((name, index) => {
    const eq = map[name] || {};
    return {
      train_member_id: startId + index,
      equipment_id: eq.equipment_id || 0,
      equipment_code: eq.equipment_code || '',
      equipment_name: eq.equipment_name || name,
      sequence_order: index + 1,
      total_area: eq.surface_area || 0,
      area_scope: 'All',
      cleaning_method: 'Manual'
    };
  });
};

const TABLET_TRAIN_NAMES = [
  'Rapid Mixer Granulator',
  'Fluid Bed Dryer -I (Gr-I)',
  "Vibro Sifter 30'' (Gr-I)",
  'Multimill (Gr-I)',
  'Octagonal Blender - 1250 Ltrs',
  'Compression-I',
  'Metal Detector -I (Compression-I)',
  'Metal Detector -II (Compression-I)',
  'De-Duster Machine-I (Compression-I)',
  'De-Duster Machine-II (Compression-I)',
  'Autocoater - 48" -II (Elicon)',
  'VTD-I (Tray)',
  'VTD-II (Tray)',
  'Inspection Tray (Tray 05)',
  'BQS',
  'Analytical balance Pan',
  'Sampling Rod',
  'Scoop (Dispensing)',
  'Scoop (Manufacturing)'
];

const CAPSULE_TRAIN_NAMES = [
  "Vibro Sifter 30'' (Capsule Blending)",
  'Multimill (Capsule Blending)',
  'Inspection Tray (Tray 05)',
  'BQS',
  'Capsule filling machine',
  'Metal Detector (Capsule filling)',
  'Octagonal Blender 1250 Ltr (Capsule Blending)',
  'Analytical balance Pan',
  'Sampling Rod',
  'Scoop (Dispensing)',
  'Scoop (Manufacturing)'
];

const DRY_SYRUP_TRAIN_NAMES = [
  'Rapid Mixer Granulator',
  'Fluid Bed Dryer -I (Gr-I)',
  "Vibro Sifter 30'' (Gr-I)",
  'Multimill (Gr-I)',
  'Octagonal Blender - 1250 Ltrs',
  'Automatic Rotary Volumetric Dry Syrup Filling Machine',
  'Analytical balance Pan',
  'Sampling Rod',
  'Scoop (Dispensing)',
  'Scoop (Manufacturing)'
];

const tabletMembers = buildMembers(tabletEquipment, TABLET_TRAIN_NAMES, 11001);
const capsuleMembers = buildMembers(capsuleEquipment, CAPSULE_TRAIN_NAMES, 12001);
const drySyrupMembers = buildMembers(drySyrupEquipment, DRY_SYRUP_TRAIN_NAMES, 13001);

export const SAMPLE_TRAIN_MEMBERS = {
  1: tabletMembers,
  2: capsuleMembers,
  3: drySyrupMembers
};
